const theme = {
  color: {
    primary: "#003580",
    primaryDim: "#1f4f9e",
    accent: "#0086e5",
    danger: "#fb4d44",
    warning: "#f5a623",
    fg: "#222222",
    muted: "#888888",
    line: "#e6e8eb",
    bg: "#f6f7f9",
    card: "#ffffff",
  },
  radius: {
    md: "10px",
    lg: "14px",
  },
  shadow: {
    card: "0 1px 2px rgba(0,0,0,0.04), 0 4px 16px rgba(0,0,0,0.06)",
  },
  pad: {
    page: "16px",
  },
};

export default theme;
